import { html } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { pdsCustomElement as customElement } from '../../decorators/pds-custom-element';
import { PdsElement } from '../PdsElement';
import { size, ListSize } from '../list/list';
import styles from './list-item.scss?inline';

/**
 * @summary A list item (li) element
 *
 * @slot default The content of the list item
 * @slot icon This slot holds an icon
 */
@customElement('pds-list-item', {
  category: 'component',
  type: 'component',
  styles,
})
export class PdsListItem extends PdsElement {
  /**
   * Size
   * Should be inherited from pds-list
   * If provided directly, renders the list with small typography
   * if icons are in the list item, they will inherit the size.
   */
  @property({ reflect: true })
  size: ListSize = 'md';

  /**
   * This grabs the icon from the slot
   * @internal
   */
  @queryAssignedElements({ slot: 'icon' })
  listItemIcons: HTMLElement[];

  addSizeTolistItemIcons() {
    if (
      this.listItemIcons &&
      this.listItemIcons.length &&
      size.includes(this.size)
    ) {
      this.listItemIcons.forEach((icon) =>
        icon.setAttribute('size', this.size),
      );
    }
  }

  updated() {
    this.addSizeTolistItemIcons();
  }

  render() {
    return html`<li class="pds-c-list-item" role="listitem">
      ${this.slotNotEmpty('icon')
        ? html`<span class="pds-c-list-item__icon-wrapper"
            ><slot name="icon" @slotchange=${this.addSizeTolistItemIcons}></slot
          ></span>`
        : ''}
      <slot></slot>
    </li>`;
  }
}
